import React, { Suspense, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AxiosInstance from 'utils/AxiosInstance'
import { Button, Card, Container, Row } from 'reactstrap'
import { CourseDetails } from '../LearningPlan'
import '../LearningPlan/style.css'
import {
  progress,
  fetchCourses,
  fetchUserProgress,
  onSearchReset,
} from 'store/Course/actions'
import {
  toggleGroupOrder,
  fetchGroups,
  fetchGroupsCourses,
  setIndividualCourses,
  fetchUserGroupProgress,
} from 'store/Group/actions'
import { reset } from 'store/Preloader/actions'
import { fetchCourseSettings } from 'store/ConfigurationSettings/CourseConfig/actions'
import { getExemptCourses } from 'store/EmployeeReport/actions'
import Loader from '../Loader'
import { useHistory, useLocation } from 'react-router'
import { setLastPathname } from 'store/Course/actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowDown,
  faArrowUp,
  faReorder,
} from '@fortawesome/free-solid-svg-icons'
import { toggleComplianceGroupOrder } from 'store/Group/actions'
import { setComplianceGroups } from 'store/Group/actions'
import { setInitialComplianceGroups } from 'store/Group/actions'
import { setComplianceGroupIndex } from 'store/Group/actions'
import { reorderComplianceGroups } from 'store/Group/actions'
import { saveComplianceGroupOrder } from 'store/Group/actions'

const LazySlider = React.lazy(() => import('../LearningPlan/Slider'))

const Compliance = (props) => {
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [groups, setGroups] = useState([])
  const coursesState = useSelector((state) => state.courses)
  const courseConfig = useSelector((state) => state.courseConfig)
  const groupState = useSelector((state) => state.groups)
  const { user } = useSelector((state) => state.auth)
  const employeeReport = useSelector((state) => state.employeeReport)

  const dispatch = useDispatch()

  useEffect(() => {
    if (!coursesState.courses.length) {
      dispatch(fetchUserProgress())
      dispatch(fetchGroups())
      dispatch(fetchCourses())
      dispatch(setIndividualCourses())
      dispatch(fetchCourseSettings())
    }

    if (!coursesState.progress.length) {
      dispatch(progress())
    }

    if (!groupState.groupsCourses.length) {
      dispatch(fetchGroupsCourses())
    }

    if (groupState.groupOrderShowing) {
      dispatch(toggleGroupOrder())
    }

    if (groupState.learningPlanGroups.length) {
      dispatch(fetchUserGroupProgress())
    }

    const { progressLoaded } = groupState
    dispatch(reset(progressLoaded))
    dispatch(getExemptCourses(user.id))

    setLoading(true)
    AxiosInstance.get('/groups/pinned')
      .then((response) => {
        if (response.pinnedGroups) {
          setGroups(response.pinnedGroups)
        } else {
          setError(response.message)
        }

        console.log(response, 'response')
        setLoading(false)
      })
      .catch((err) => {
        console.log(err)
        setLoading(false)
      })
    return () => {
      dispatch(onSearchReset())
    }
  }, [])

  // const groupState?.complianceGroups? = groupState.groups.filter(
  //   (item) => item.type === 'course' && groups.includes(item.id)
  // )

  useEffect(() => {
    dispatch(setLastPathname(location.pathname))
  }, [])

  useEffect(() => {
    if (!groupState?.complianceGroups?.length) {
      if (groups.length) {
        const complianceGroups = groupState?.groups?.filter(
          (item) => item.type === 'course' && groups.includes(item.id)
        )
        const sortedComplianceGroups = complianceGroups.sort(
          (a, b) => a.compliance_position - b.compliance_position
        )
        dispatch(setComplianceGroups(sortedComplianceGroups))
        dispatch(setInitialComplianceGroups(sortedComplianceGroups))
      }
    }
  }, [
    groups,
    props,
    dispatch,
    groupState?.complianceGroups?.length,
    groupState?.groups,
  ])

  return (
    <Container className='mt--6' fluid>
      <Card className='mt--6 py-4 px-3' style={{ minHeight: '85vh' }}>
        {[1, 4].includes(user.access) ? (
          <>
            <Button
              color='white'
              size='sm'
              className='border-none px-md-3 mb-5 py-2 reorder-button ml-auto'
              style={{ width: 'fit-content', marginRight: '2rem' }}
              onClick={() => dispatch(toggleComplianceGroupOrder())}
            >
              <FontAwesomeIcon icon={faReorder} className='btn-icon' />
              <span>Reorder</span>
            </Button>
            {groupState?.complianceGroupOrderShowing ? (
              <ReoderItems {...props} complianceGroupsIds={groups} />
            ) : null}
          </>
        ) : null}
        {loading ? (
          <div
            className='dFlex justifyCenter itemsCenter textCenter'
            style={{ minHeight: '80vh' }}
          >
            <Loader />
          </div>
        ) : (
          <div style={{ minHeight: '80vh' }}>
            <Suspense
              fallback={
                <div
                  className='dFlex justifyCenter itemsCenter textCenter'
                  style={{ minHeight: '80vh' }}
                >
                  <Loader />
                </div>
              }
            >
              {groupState?.complianceGroups?.length === 0 ? (
                <div
                  className='dFlex justifyCenter itemsCenter textCenter'
                  style={{ minHeight: '80vh' }}
                >
                  <p className='text-primary blockquote font-weight-normal'>
                    No data here
                  </p>
                </div>
              ) : (
                groupState?.complianceGroups?.map((group) => {
                  const groupCourses = (
                    groupState.groupsCourses[group.id] || []
                  ).map((item) => item.course_id)

                  let courses = []

                  groupCourses.forEach(
                    (id) =>
                      (courses = [
                        ...courses,
                        ...coursesState.progress.filter(
                          (course) => course.id === id
                        ),
                      ])
                  )
                  courses = courses.filter(
                    (item) =>
                      !employeeReport.exemptCourses.find(
                        (exemptCourse) => exemptCourse.course_id === item.id
                      )
                  )

                  if (groupCourses.length && !courses.length) {
                    return null
                  }

                  return (
                    <LazySlider
                      key={group.id}
                      sectionTitle={group.name}
                      id={group.id}
                      inactive={group.inactive}
                      access={user.access}
                    >
                      {courses.length > 0 ? (
                        courses.map((item, courseIndex) => (
                          <CourseDetails
                            courseState={coursesState}
                            key={item.course_id}
                            course={item}
                            user={user}
                            courseIndex={courseIndex}
                            courseConfig={courseConfig}
                          />
                        ))
                      ) : (
                        <p className='text-primary blockquote font-weight-normal'>
                          No data here
                        </p>
                        // <Loader />
                      )}
                    </LazySlider>
                  )
                })
              )}
            </Suspense>

            {error && (
              <div
                className='dFlex justifyCenter itemsCenter textCenter'
                // style={{ minHeight: '80vh' }}
              >
                {/* <p className='text-primary blockquote font-weight-normal'>
                  {error}
                </p> */}
              </div>
            )}
          </div>
        )}
      </Card>
    </Container>
  )
}

const ReoderItems = (props) => {
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const groupState = useSelector((state) => state.groups)
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)
  const coursesState = useSelector((state) => state.courses)

  const language = languageRedux || {}
  const [reordered, setReordered] = useState(false)

  const reorderRef = useRef()

  useEffect(() => {
    const handleReorderClick = (e) => {
      const isReorderButton = e.target.closest('.reorder-button')

      if (
        reorderRef.current &&
        groupState.complianceGroupOrderShowing &&
        !reorderRef.current.contains(e.target) &&
        !isReorderButton
      ) {
        dispatch(toggleComplianceGroupOrder())
      }
    }

    document.addEventListener('click', handleReorderClick, true)

    return () => {
      document.removeEventListener('click', handleReorderClick, true)
    }
  }, [groupState.complianceGroupOrderShowing, dispatch])

  return (
    <div ref={reorderRef} className='reorder-items-wrapper'>
      <div>
        <p>
          {language.learning_plan
            ? language.learning_plan.reorder_groups_courses
            : null}
        </p>
      </div>
      <div className='scrollbar reorder-items-list'>
        {groupState?.complianceGroups &&
          groupState?.complianceGroups
            .filter(
              (item) =>
                item.type === 'course' &&
                (props.access === 1 || item.owner === 1) &&
                props.complianceGroupsIds.includes(item.id)
            )
            .map((group, index) => {
              return (
                <div key={group.id}>
                  {(() => {
                    const groupCourses = (
                      groupState?.groupsCourses[group.id] || []
                    ).map((item) => item.course_id)

                    let courses = []
                    groupCourses?.map(
                      (id) =>
                        (courses = [
                          ...courses,
                          ...coursesState.progress.filter(
                            (course) => course.id === id
                          ),
                        ])
                    )
                    return (
                      <div>
                        <div
                          onClick={() =>
                            dispatch(setComplianceGroupIndex(index))
                          }
                          className={`category-name-wrapper${
                            groupState?.complianceGroupIndex === index
                              ? ' selected'
                              : ''
                          }`}
                        >
                          <h2 className='category-name'>{group.name}</h2>
                          {/* { props.courses.length ? (
                                            <button className='btn btn-default btn-transparent'>
                                                <span className='icon fas fa-angle-down'></span>
                                            </button>
                                            ) : null } */}
                        </div>
                        {/* <ul
                        style={{
                          display:
                            props.complianceGroupIndex === index ? "" : "none",
                        }}
                      >
                        {courses.map((item, index) => (
                          <li
                            key={item.id}
                            onClick={() => props.setCourseIndex(index)}
                            className={
                              props.courseIndex === index ? "selected" : ""
                            }
                          >
                            {item.name}
                          </li>
                        ))}
                      </ul> */}
                      </div>
                    )
                  })()}
                </div>
              )
            })}
      </div>

      {(() => {
        switch (true) {
          case groupState?.courseIndex === null:
            return (
              <Row className='justify-content-center pb-3'>
                <button
                  onClick={() => {
                    setReordered(true)
                    if (groupState.complianceGroupIndex > 0) {
                      dispatch(
                        reorderComplianceGroups(
                          groupState.complianceGroupIndex - 1
                        )
                      )
                    }
                  }}
                  title='Bring item up'
                  style={{ padding: '2px 10px' }}
                  className='btn btn-transparent border'
                >
                  <FontAwesomeIcon
                    className='cursor-pointer font-weight-bolder text-center'
                    icon={faArrowUp}
                    // onClick={close}
                  />
                </button>
                <button
                  onClick={() => {
                    setReordered(true)

                    if (
                      groupState.complianceGroupIndex <
                      groupState.complianceGroups.length - 1
                    ) {
                      dispatch(
                        reorderComplianceGroups(
                          groupState.complianceGroupIndex + 1
                        )
                      )
                    }
                  }}
                  style={{ padding: '2px 10px' }}
                  title='Bring item down'
                  className='btn btn-transparent border'
                >
                  <FontAwesomeIcon
                    className='cursor-pointer font-weight-bolder text-center'
                    icon={faArrowDown}
                  />
                </button>
              </Row>
            )
          case props.complianceGroupIndex === null:
            let _groupCourses = []

            Object.keys(props.groupsCourses).map(
              (groupId) =>
                (_groupCourses = [
                  ..._groupCourses,
                  ...props.groupsCourses[groupId].map((item) => item.course_id),
                ])
            )

            return (
              <div className='reorder-btn-wrapper bg-danger'>
                <button
                  onClick={() =>
                    props.courseIndex > 0
                      ? props.reorderItems(props.courseIndex - 1)
                      : null
                  }
                  title='Bring item up'
                  className='btn btn-default course-reorder-btn reorder-btn-up'
                >
                  <FontAwesomeIcon icon='caret-up' />
                </button>
                <button
                  onClick={() =>
                    props.courseIndex < props.individualCourses.length - 1
                      ? props.reorderItems(props.courseIndex + 1)
                      : null
                  }
                  title='Bring item down'
                  className='btn btn-default course-reorder-btn reorder-btn-down'
                >
                  <FontAwesomeIcon icon='caret-down' />
                </button>
              </div>
            )
          default:
            const groupId =
              props.learningPlanGroups[props.complianceGroupIndex].id
            const groupCourses = (props.groupsCourses[groupId] || []).map(
              (item) => item.course_id
            )

            return (
              <div className='reorder-btn-wrapper'>
                <button
                  onClick={() =>
                    props.courseIndex > 0
                      ? props.reorderItems(props.courseIndex - 1)
                      : null
                  }
                  title='Bring item up'
                  className='btn btn-default course-reorder-btn reorder-btn-up'
                >
                  <FontAwesomeIcon icon='caret-up' />
                </button>
                <button
                  onClick={() =>
                    props.courseIndex < groupCourses.length - 1
                      ? props.reorderItems(props.courseIndex + 1)
                      : null
                  }
                  title='Bring item down'
                  className='btn btn-default course-reorder-btn reorder-btn-down'
                >
                  <FontAwesomeIcon icon='caret-down' />
                </button>
              </div>
            )
        }
      })()}
      <div style={{ textAlign: 'left' }} className='pt-2 '>
        <Button
          onClick={() => dispatch(saveComplianceGroupOrder())}
          className='btn btn-info mr-2'
          size='sm'
        >
          {language.general ? language.general.save : null}
        </Button>
        <button
          onClick={() => dispatch(toggleComplianceGroupOrder())}
          className='btn text-info bg-transparent border-0'
          size='sm'
          style={{ padding: '4px 8px', fontSize: '12px' }}
        >
          {language.general ? language.general.cancel : null}
        </button>
      </div>
    </div>
  )
}

export default Compliance
